import { Helmet } from 'react-helmet-async';
import { Container, Stack, Typography } from '@mui/material';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import type { RoadmapSummary } from "../api/roadmap-service";
import { roadmapCoverUrl, RoadmapService } from "../api/roadmap-service";
import { CatalogCard } from '../components/catalog/CatalogCard';
import { RoadmapParents } from '../components/roadmaps/RoadmapParents';
import { CatalogGroup } from '../components/catalog/CatalogGroup';
import ENV from "../env";
import { CatalogHeader } from "../components/catalog/CatalogHeader";
import { byTitle } from "../utils/by-title";

/** The roadmap catalogue: one card per role, base roles included, in alphabetical order. */
export function RoadmapsPage() {
    const navigate = useNavigate();

    const [ roadmaps, setRoadmaps ] = useState<RoadmapSummary[]>([]);
    const [ loading, setLoading ] = useState(true);

    useEffect(() => {
        RoadmapService.roadmaps()
            .then(setRoadmaps)
            .catch((reason) => console.error("Unable to load roadmaps: ", reason))
            .finally(() => setLoading(false));
    }, []);

    return <>
        <Helmet>
            <title>Roadmaps | { ENV.APP_NAME }</title>
        </Helmet>

        <Container maxWidth="xl">
            <Stack spacing={ 4 }>
                <CatalogHeader title="Roadmaps" subtitle="What a role is expected to know, belt by belt, built from the courses."/>

                { !loading && !roadmaps.length && (
                    <Typography>No roadmaps available right now.</Typography>
                ) }

                { roadmaps.length > 0 && (
                    <CatalogGroup title="Roles" count={ `${ roadmaps.length } ${ roadmaps.length === 1 ? 'role' : 'roles' }` }>
                        { [ ...roadmaps ].sort(byTitle).map((roadmap) => (
                            <CatalogCard key={ roadmap.id }
                                         item={ {
                                             cover: roadmapCoverUrl(roadmap),
                                             title: roadmap.title,
                                             size: roadmap.lessons,
                                             counter: 'lessons',
                                             subtitle: roadmap.parents.length > 0 && (
                                                 <RoadmapParents parents={ roadmap.parents }
                                                                 onOpen={ (id) => navigate(`/roadmaps/${ id }`) }/>
                                             ),
                                         } }
                                         onClick={ () => navigate(`/roadmaps/${ roadmap.id }`) }/>
                        )) }
                    </CatalogGroup>
                ) }
            </Stack>
        </Container>
    </>;
}
